// Auto-generated normalizer for table: Empleados_Proyectos
export function empleadosProyectosNormalize(row) {
  return {
    idEmpleadoProyecto: row.idEmpleadoProyecto ?? row.IdEmpleadoProyecto ?? row['IdEmpleadoProyecto'] ?? 0,
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['IdEmpleado'] ?? 0,
    idProyecto: row.idProyecto ?? row.IdProyecto ?? row['IdProyecto'] ?? 0,
    rolEnProyecto: row.rolEnProyecto ?? row.RolEnProyecto ?? row['RolEnProyecto'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaAsignacion: row.fechaAsignacion ?? row.FechaAsignacion ?? row['FechaAsignacion'] ?? null,
  };
}
